<template>
	<el-container class="system-setting">
		<Signature class="signature" ref="signature" :User_code="User_code" v-show="show_signature"
			@closeSignature="closeSignature"></Signature>
		<el-header v-show="!show_signature" class="header">
			<span>系统设置</span>
			<i class="el-icon-close" @click="close"></i>
		</el-header>
		<el-main v-show="!show_signature" class="main">
			<div class="left">
				<div @click="changeTab(1)" :class="['left-item',active==1?'active':'']">声音提醒设置</div>
				<div @click="changeTab(2)" :class="['left-item',active==2?'active':'']">个人签名设置</div>
				<div @click="changeTab(3)" :class="['left-item',active==3?'active':'']">自动回复设置</div>
			</div>
			<div class="right">
				<!-- 状态设置 -->
				<div class="status-set">
					<div class="status-block" v-show="active==1">
						<div class="content-left">声音提醒</div>
						<span class="content-right flex-box">
							<div class="title-right">
								消息免打扰
							</div>
							<el-switch v-model="disturb" active-color="#13ce66" inactive-color="#ff0000"
								@change="modifyDisturbStatus">
							</el-switch>
						</span>
					</div>
					<div class="status-block" v-show="active==2">
						<div class="content-left">个性签名</div>
						<span class="content-right">
							<div class="title-right">点击设置个性签名(个人版本/团队版本)</div>
							<button class="btn" @click="showSignature">个性签名</button>
						</span>
					</div>
					<div class="status-block" v-show="active==3">
						<div class="content-left">自动回复</div>
						<span class="content-right">
							<div class="title-right">点击设置自动回复(个人版本/团队版本)</div>
							<button class="btn" @click="openAutoReplyDia">自动回复</button>
						</span>
					</div>
				</div>
			</div>
		</el-main>
		<!-- 自动回复的弹窗 -->
		<el-dialog title="自动回复设置" width="570px" :visible.sync="showAutoReplyDialog">
			<div class="autoReplyDialog">
				<el-checkbox class="autoReplyCheck" @change='swtichAutoReply' :checked="autoReplyOption.if_show==1"
					true-label=1 false-label=2 v-model="autoReplyOption.if_show">当天第一次收到买家消息时自动回复</el-checkbox>
				<div class="input-row">
					<input class="input" v-model="autoReplyOption.reply_txt" placeholder="请输入文字回复" />
					<div class="btn" size="mini" @click="addAutoReply">修改</div>
				</div>
				<div class="related-issues-row">
					<span class="related-issues-num">关联问题:&nbsp;&nbsp;{{autoReplyOption.related_id==0?0:1}}个</span>
					<span class="related-issues-choose" @click="getAutoProblem">重新选择</span>
				</div>
			</div>
			<el-dialog title="团队知识库" width="660px" class="relatedIssuesDialog" :visible.sync="showRelatedIssuesDialog"
				append-to-body>
				<div class="relatedIssues-tips">首问自动回复只能关联1-10的数字问题，全部数字问题的编辑和修改请到机器人配置中操作</div>
				<div class="table">
					<div class="thead">
						<div class="td" style="width: 88px;text-align: center;">数字标签</div>
						<div class="td" style="width: 216px;text-align: left;box-sizing: border-box;padding: 0 15px;">
							买家问题描述（最多30字）</div>
						<div class="td" style="width: 232px;text-align: left;box-sizing: border-box;padding: 0 15px;">
							问题回答（最多40字）</div>
						<div class="td" style="width: 70px;text-align: center;">操作</div>
					</div>
					<div :class="['tbody',item.is_edit?'is_edit':'']" v-for="(item,index) in problem"
						:key="item.related_id">
						<div class="td" style="width: 88px;text-align: center;">
							<el-radio :label="item.related_id" v-model="autoReplyOption.related_id">{{index}}</el-radio>
						</div>
						<div class="td" style="width: 216px;text-align: center;">
							<el-input type="textarea" resize="none" maxlength="30" :readonly="!item.is_edit"
								:rows="item.is_edit?4:1" placeholder="请输入问题" v-model="item.related_txt">
							</el-input>
						</div>
						<div class="td" style="width: 232px;text-align: left;">
							<el-input type="textarea" resize="none" maxlength="40" :readonly="!item.is_edit"
								:rows="item.is_edit?4:1" placeholder="请输入答案" v-model="item.answer_txt">
							</el-input>
						</div>
						<div class="td option" style="width: 70px;text-align: center;">
							<span @click="item.is_edit = true" style="color: #5792fa;" v-show="!item.is_edit">修改</span>
							<span @click="dropItem(index)" style="color: #f60000;" v-show="!item.is_edit">删除</span>
							<span @click="editItem(index)" style="color: #5792fa;" v-show="item.is_edit">保存</span>
							<span @click="item.is_edit = false" v-show="item.is_edit">取消</span>
						</div>
					</div>

				</div>
				<div class="addProblem" @click="addProblemItem">添加新的问题</div>
				<div class="canAddProblemNum">还可添加{{parseInt(10-problem.length)}}个问题</div>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" size="mini" @click="chooseRelatedIssues">确定</el-button>
					<el-button size="mini" @click="showRelatedIssuesDialog = false">取消</el-button>
				</div>
			</el-dialog>
		</el-dialog>
	</el-container>
</template>

<script>
	import Signature from '@/components/Signature.vue'
	export default {
		name: 'SystemSetting',
		data() {
			return {
				active: 0,
				show_signature: false, //是否显示个性签名
				disturb: false, //组件内部的消息免打扰 0接收，1关闭接收
				signature: '',
				showAutoReplyDialog: false, // 是否显示自动回复对话框
				showRelatedIssuesDialog: false, // 是否显示关联问题对话框
				autoReplyOption: {
					if_show: false,
					related_id: 0
				},
				problem: [], //问题列表
				related_id: '', //关联问题中的关联id 
			}
		},
		components: {
			Signature
		},
		props: {
			User_code: String,
		},
		methods: {
			close() {
				this.$emit('closePop')
			},
			// 自定义索引
			indexMethods(index) {
				return index + 1
			},
			// 开关自动回复
			async swtichAutoReply() {
				if(!this.autoReplyOption.id){
					this.$message.warning('开启自动回复前需要先设置回复内容或者关联问题')
					this.autoReplyOption.if_show = 2
					return
				}
				let res = await this.$axios.post('/autoReply/addAutoReply', {
					kf_id: this.User_code,
					type: 1,
					if_show: this.autoReplyOption.if_show,
					cz_type: this.autoReplyOption.id ? 1 : 0
				})
				if(!res.data.done){
					this.$message.error(res.data.msg)
					return
				}
				this.$message.success(res.data.msg)
			},
			// 选择关联问题
			async chooseRelatedIssues() {
				this.showRelatedIssuesDialog = false
				console.log('kf_id', this.User_code)
				console.log('related_id', this.autoReplyOption.related_id)
				console.log('if_show', this.autoReplyOption.if_show)
				console.log('cz_type', this.autoReplyOption.id ? 1 : 0)
				let res = await this.$axios.post('/autoReply/addAutoReply', {
					kf_id: this.User_code,
					type: 1,
					related_id: this.autoReplyOption.related_id,
					if_show: this.autoReplyOption.if_show,
					cz_type: this.autoReplyOption.id ? 1 : 0
				})
				if(!res.data.done){
					this.$message.error(res.data.msg)
					return
				}
				// this.getAutoReply()
			},
			// 打开自动回复
			openAutoReplyDia() {
				this.showAutoReplyDialog = true
			},
			//显示个性签名
			showSignature() {
				this.show_signature = true
				console.log(this.signature)
				this.$refs.signature.textarea = this.signature
			},
			//关闭个性签名
			closeSignature() {
				this.show_signature = false
			},
			// 修改个人状态
			async modifyDisturbStatus() {
				var that = this
				if (that.disturb) {
					that.disturb = 1;
				} else {
					that.disturb = 0;
				}
				var res = await that.$axios.post('/friends/editUserInfo', {
					User_code: that.User_code,
					param: that.disturb,
					type: 'disturb_status'
				})
				if (res.data.done) {
					that.$message.success('修改成功')
					this.$emit('editDisturb')
					if (that.disturb == 1) {
						that.disturb = true;
					} else {
						that.disturb = false;
					}
				} else {
					that.$message.error(res.data.msg);
				}
			},
			changeTab(index) {
				this.active = index;
			},
			// 新增或者修改自动回复
			async addAutoReply() {
				let res = await this.$axios.post('/autoReply/addAutoReply', {
					kf_id: this.User_code,
					type: 1,
					reply_txt:this.autoReplyOption.reply_txt,
					if_show: this.autoReplyOption.if_show,
					cz_type: this.autoReplyOption.id ? 1 : 0
				})
				if(!res.data.done){
					this.$message.warning(res.data.msg)
					return
				}
				this.$message.success(res.data.msg)
			},
			// 获取关联问题列表
			async getAutoProblem() {
				this.showRelatedIssuesDialog = true
				var res = await this.$axios.post('/autoProblem/showAutoProblem', {
					kf_id: this.User_code,
				})
				if (!res.data.done) {
					return
				}
				res.data.data.map((item, index) => {
					item.is_edit = false
				})
				this.problem = res.data.data
			},

			// 获取自动回复内容
			async getAutoReply() {
				var res = await this.$axios.post('/autoReply/showAutoReply', {
					kf_id: this.User_code,
					type: 1
				})
				if (!res.data.done) {
					this.autoReplyOption.if_show = false
					return
				}
				this.autoReplyOption = res.data.data
			},
			// 添加关联问题
			addProblemItem() {
				this.problem.push({
					answer_txt: '',
					related_id: 0,
					related_txt: '',
					is_edit: false
				})
			},
			// 编辑或新增关联问题
			async editItem(index) {
				console.log(index)
				console.log(this.problem[index])
				console.log('kf_id', this.User_code)
				console.log('related_txt', this.problem[index].related_txt)
				console.log('answer_txt', this.problem[index].answer_txt)
				console.log('操作类型',this.problem[index].related_id)
				let res = await this.$axios.post('/autoProblem/addAutoProblem', {
					kf_id: this.User_code,
					type: 1,
					related_txt: this.problem[index].related_txt,
					answer_txt: this.problem[index].answer_txt,
					related_id: this.problem[index].related_id,
					cz_type: this.problem[index].related_id ? 1 : 0
				})
				if (!res.data.done) {
					return
				}
				this.problem[index].is_edit = false
				this.getAutoProblem()
			},
			// 删除关联问题
			async dropItem(index) {
				let res = await this.$axios.post('/autoProblem/dropAutoProblem', {
					related_id: this.problem[index].related_id,
				})
				if (!res.data.done) {
					return
				}
				this.problem.splice(index, 1)
			}
		},
		created() {
			this.getAutoReply()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.system-setting {
		width: 660px;
		height: 440px;
		font-size: 14px;
		color: #333;
	}

	.header {
		margin: 0;
		padding: 0 24px;
	}

	.main {
		margin: 0;
		padding: 0;
	}

	.header {
		background-color: #354052;
		color: #fff;
		display: flex;
		box-sizing: border-box;
		justify-content: space-between;
		align-items: center;
		height: 40px;
		font-size: 14px;
	}

	.header i {
		font-size: 22px;
	}

	.main .left {
		width: 118px;
		display: inline-block;
		background-color: #e0e7f1;
		color: #333;
		height: 100%;
		float: left;
	}

	.active {
		background-color: #4b73ec;
		color: #fff;
	}

	.main .left .left-item {
		height: 40px;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 14px;
	}

	.main .right {
		width: calc(100% - 118px);
		display: inline-block;
		font-size: 14px;
		box-sizing: border-box;
		color: #888888;
		overflow: auto;
		box-sizing: border-box;
		float: left;
		height: 100%;
	}

	.status-set,
	.status-block {
		width: 100%;
		height: 100%;
	}

	.content-left {
		width: 115px;
		height: 100%;
		box-sizing: border-box;
		padding: 20px;
		font-size: 14px;
		color: #333;
		display: inline-block;
		float: left;
	}

	.content-right {
		width: calc(100% - 115px);
		height: 100%;
		box-sizing: border-box;
		padding: 20px;
		font-size: 14px;
		color: #333;
		display: inline-block;
		float: left;
	}

	.content-right .title-right {
		width: 100%;
		height: 16px;
		margin-bottom: 13px;
	}

	.btn {
		width: 106px;
		height: 20px;
		border: 1px solid #888;
		box-sizing: border-box;
		border-radius: 2px;
		background-color: #fff;
	}

	.btn:focus {
		border: 1px solid #ccc !important;
		outline: none;
	}

	.signature {
		width: 100%;
		height: 100%;
	}

	.flex-box {
		display: flex;
		justify-content: space-between;
	}

	.autoReplyCheck {
		margin-bottom: 14px;
	}

	.input-row {
		display: flex;
		height: 40px;
		justify-content: space-between;
		align-items: center;
	}

	.input-row .input {
		width: 367px;
		margin-left: 24px;
		height: 22px;
		outline: none;
		border: 1px solid #eee;
		font-size: 14px;
	}

	.input-row .btn {
		width: 70px;
		height: 22px;
		text-align: center;
		font-size: 14px;
	}

	.related-issues-row {
		margin-top: 14px;
		font-size: 14px;
	}

	.related-issues-num {
		color: #888;
	}

	.related-issues-choose {
		color: #5792fa;
		margin-left: 16px;
		cursor: pointer;
	}

	.relatedIssues-tips {
		color: #96aef5;
		font-size: 12px;
		width: 100%;
		text-align: center;
		margin-top: 12px;
		margin-bottom: 24px;
	}

	.addProblem {
		width: 602px;
		height: 27px;
		background-color: #f5f5f5;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 33px auto 10px;
		cursor: pointer;
	}

	.canAddProblemNum {
		font-size: 12px;
		display: flex;
		margin: auto;
		width: 602px;
		display: flex;
		justify-content: center;
		color: #888888;
	}

	.relatedIssuesDialog .table {
		width: 100%;
	}

	.relatedIssuesDialog .thead,
	.relatedIssuesDialog .tbody {
		display: flex;
		height: 34px;
		align-items: center;
		flex-wrap: nowrap;
		border-bottom: 1px solid #f5f5f5;
	}

	.relatedIssuesDialog .tbody .option span {
		cursor: pointer;
	}

	.relatedIssuesDialog .tbody .option span:nth-child(odd) {
		margin-right: 7px;
	}

	.relatedIssuesDialog .is_edit {
		height: 110px !important;
	}
</style>
